/**
 * Portfolio API Service
 * Handles all API calls related to portfolio management
 */

import api from '../api';

/**
 * Sync portfolio with broker
 * @param {string} broker - Broker name (default: 'ZERODHA')
 * @returns {Promise} API response
 */
export const syncPortfolio = async (broker = 'ZERODHA') => {
  try {
    console.log('--- DEBUG: syncPortfolio called ---');
    console.log('URL path: /api/v1/portfolio/sync');
    console.log('Broker:', broker);
    const response = await api.post('/api/v1/portfolio/sync', { broker });
    console.log('syncPortfolio response:', response.data);
    return response.data;
  } catch (error) {
    console.error('--- DEBUG: Error syncing portfolio ---');
    console.error('Full error:', error);
    console.error('Error response:', error.response);
    console.error('Error status:', error.response?.status);
    console.error('Error data:', error.response?.data);
    throw error;
  }
};

/**
 * Get portfolio positions with real-time prices
 * @returns {Promise} Portfolio positions with P&L metrics
 */
export const getPositions = async () => {
  try {
    console.log('--- DEBUG: getPositions called ---');
    console.log('URL path: /api/v1/portfolio/positions');
    const response = await api.get('/api/v1/portfolio/positions');
    console.log('getPositions response:', response.data);
    return response.data;
  } catch (error) {
    console.error('--- DEBUG: Error fetching positions ---');
    console.error('Full error:', error);
    console.error('Error response:', error.response);
    console.error('Error status:', error.response?.status);
    console.error('Error data:', error.response?.data);
    throw error;
  }
};

/**
 * Get order history (DEPRECATED - Use getBrokerOrders instead)
 * @param {Object} params - Query parameters (page, page_size, broker, status_filter)
 * @returns {Promise} Paginated order list
 * @deprecated This endpoint queries local database cache. Use getBrokerOrders for live data.
 */
export const getOrders = async (params = {}) => {
  try {
    console.log('--- DEBUG: getOrders called (DEPRECATED) ---');
    console.log('URL path: /api/v1/portfolio/orders');
    console.log('Params:', params);
    const response = await api.get('/api/v1/portfolio/orders', { params });
    console.log('getOrders response:', response.data);
    return response.data;
  } catch (error) {
    console.error('--- DEBUG: Error fetching orders ---');
    console.error('Full error:', error);
    console.error('Error response:', error.response);
    console.error('Error status:', error.response?.status);
    console.error('Error data:', error.response?.data);
    throw error;
  }
};

/**
 * Get LIVE order history directly from broker API
 * This fetches real-time order data from the broker's servers (e.g., Zerodha)
 * @param {string} brokerName - Broker name (e.g., 'ZERODHA')
 * @param {Object} params - Query parameters (status_filter)
 * @returns {Promise} Live orders from broker API
 */
export const getBrokerOrders = async (brokerName = 'ZERODHA', params = {}) => {
  try {
    console.log('--- DEBUG: getBrokerOrders called ---');
    console.log('Broker:', brokerName);
    console.log('URL path: /api/v1/brokers/' + brokerName + '/orders');
    console.log('Params:', params);
    
    const response = await api.get(`/api/v1/brokers/${brokerName}/orders`, { params });
    console.log('getBrokerOrders response:', response.data);
    return response.data;
  } catch (error) {
    console.error('--- DEBUG: Error fetching broker orders ---');
    console.error('Full error:', error);
    console.error('Error response:', error.response);
    console.error('Error status:', error.response?.status);
    console.error('Error data:', error.response?.data);
    throw error;
  }
};

